import { render, staticRenderFns } from "./QueryRunVersion.vue?vue&type=template&id=ecefdc28&"
import script from "./QueryRunVersion.vue?vue&type=script&lang=js&"
export * from "./QueryRunVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports